import { css } from '@emotion/react';
import { semantic_colors, text_styles } from '../../foundation';
import { InputStatus } from '../input/types';
import { input_status_color_css } from '../input/styles';

export const label_base_css = css`
  flex: none;
  display: inline-flex;
  align-items: center;
  ${text_styles.Body_13_SemiBold};
  color: ${semantic_colors.content.secondary};
`;

export const getFormHelperStatus = (kind: InputStatus) => {
  switch (kind) {
    case 'success':
      return css`
        color: ${input_status_color_css.success};
      `;
    case 'error':
      return css`
        color: ${input_status_color_css.error};
      `;
    case 'info':
    default:
      return css`
        color: ${semantic_colors.content.tertiary};
      `;
  }
};
